import React from "react";
import "./Leave.css";
import { useNavigate } from "react-router-dom";
import MobileLayout from "../../../layouts/MobileLayout";
import Leaveform from "./Leaveform";





const leaveData = [
    {
        title: "Casual Leave",
        remaining: 7,
        total: 12,
        used: 5,
    },
    {
        title: "Sick Leave",
        remaining: 6,
        total: 8,
        used: 5,
    },
    {
        title: "Priviledge Leave",
        remaining: 17,
        total: 20,
        used: 3,
    },
    {
        title: "Birthday Leave",
        remaining: 1,
        total: 1,
        used: 1,
    },
];

const Leave = () => {

    const navigate = useNavigate();
    return (

        <MobileLayout>
       


        </MobileLayout>

        
    );
};

export default Leave;